<template>
    <span>
        <v-dialog max-width="600px">
        <span column slot="activator" class="fab-container">
            <v-btn icon class="mx-0" @click="edit(name,price)">
                      <v-icon color="black">credit_card</v-icon>
           </v-btn>
           
        </span>
         <v-card
          flat
          class="flex"
         >
             <v-card-title primary-title>
                <h1 class="headline mb-1"><b>SELL REFRESHMENT</b></h1>

             </v-card-title>
              
             <v-card-text class=" text-xs-center display-1  my-2 flex">
                
                
             </v-card-text>
             <v-card-text>
                 <v-form class="px-3" ref="editform"> 
                     <v-text-field label="Refreshment Name*" v-model="nameloc" readonly prepend-icon="comment"></v-text-field>
                     <v-text-field label="Refreshment Price*" v-model="priceloc" readonly prepend-icon="money"></v-text-field>
                     <v-select label="Quantity*" item-text="qty" :items="[{header:'Quantity'},'1','2','3','4','5','6','7','8','9','10']" v-model="quantity"  prepend-icon="more"></v-select>
                     <span v-if="error_state" class="red--text">{{error_value}}</span>
                    <span> * indicates required field </span>
                </v-form>
             </v-card-text>
             <v-divider></v-divider>
              <v-card-actions>
                <v-btn outline block color="brown" @click="add()" :disabled="isDisabled" :loading="isDisabled">SELL </v-btn>
             </v-card-actions>
         </v-card>
        </v-dialog>
   </span>
</template>

<script>
import {addModule} from '@/model';
import {generateId} from '@/validator';
import moment from 'moment';


export default {
    name: 'SellRefreshment',
    props:{
        name:{
             required:true
        },
        price:{
            required:true
        }

    },computed:{
                 nameloc:{
                 get:function(){
                     return this.nameda;
                 },
                 set:function(name){
                      this.nameda = name
                 }
                     
                 },
                 priceloc:{
                 get:function(){
                     return this.priceda;
                 },
                 set:function(price){
                      this.priceda = price
                 }
                     
                 }

      
    },
    data() {
        return {
            staff:this.$store.getters.getStaff,
            error_state:false,
            error_value:"You must select a quantity",
            isDisabled:false,
            nameda:this.name,
            priceda:this.price,
            quantity:'',
            nameRules:[
               v => v.length >=2  || "Minimum length is 3 characters",
               v => v.length <=30  || "Maximum length is 20 characters" 
           ],
            priceRules:[
               v => v.length >=2  || "Minimum length is 2 characters",
               v => v.length <=30  || "Maximum length is 5 characters" 
           ]



        };
    },
    methods: {
        edit(name,price){
            console.log("Edit ",name);
            this.nameda = name; 
            this.priceda = price;
        },
        isName:function(evt){
            evt = (evt) ? evt : window.event;
            let charcode = (evt.which) ? evt.which : evt.keycode;
            if((charcode > 31 && (charcode < 48 || charcode > 57)) && charcode !== 46 && charcode !== 32){
                return true;
            }else{
                evt.preventDefault();
            }
        },
        isNumber:function(evt){
            evt = (evt) ? evt : window.event;
            let charcode = (evt.which) ? evt.which : evt.keycode;
            if((charcode > 31 && (charcode < 48 || charcode > 57)) || charcode == 46){
                evt.preventDefault();
            }else{
                return true;
            }
        },
        add() {
            let self=this;
            if(this.$refs.editform.validate()){
            if(this.quantity==0){
                    self.error_state = true;
                    
                    return
            }
            let amount = (Number(this.price) * this.quantity);
            let o = self.quantity > 1 ? ' quantities of ' : ' quantity of';
            let confirmed =  confirm('You are about to sell '+self.quantity+o+
            this.nameda+' costing a total of N'+amount+'\n Continue?',
            'Exodus');
            let ref_id = generateId('ref');
            self.error_state = false;
            if(confirmed){
            
           
            let datenow = moment().format('DD/MM/YYYY');
            
            let useradd = this.$store.getters.getStaff.name;
            let newitem = {name:ref_id,type:'refreshment',ref_name:this.nameda.toLowerCase(),quantity:Number(this.quantity),price:Number(this.priceda),amount:amount,dateadded:datenow,usersold:useradd};
            console.log(newitem);
            self.isDisabled = true;
            addModule('ticket',newitem.name,newitem,function(response){
                if(response){
                    console.log("This is response: ",response);
                     alert('Refreshment has been sold');
                     self.isDisabled = false;
                    
                    //self.$store.dispatch('updateRefreshments');
                  
                  }else{
                      console.log(null);
                      self.isDisabled = false;
                    
                  }

              });
                    }
                          }
        }
    }
};
</script>

<style scoped>
</style>